import React, { Component } from "react";
import { Link } from "react-router";
import moment from "moment";
import { Checkbox } from "material-ui";

const roles = [
  { value: 0, label: "GP" },
  { value: 1, label: "GP Trainee" },
  { value: 2, label: "Nurse" },
  { value: 3, label: "Consultant" },
  { value: 4, label: "NCHD (Hospital Doctor)" },
  { value: 5, label: "Sponsor" },
  { value: 6, label: "Nurse Specialist/ANP" },
  {
    value: 7,
    label: "Allied Healthcare Professional",
  },
  { value: 9, label: "Pharmacy" },
  { value: 11, label: "Industry" },
];

class ApproveBookingItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isVisible: true,
    };
  }

  onBookingApproveHandler = () => {
    this.props.onBookingApprove(this.props.booking && this.props.booking.id);
    this.setState({ isVisible: false });
  };

  onBookingRejectHandler = () => {
    this.props.onBookingReject(this.props.booking && this.props.booking.id);
    this.setState({ isVisible: false });
  };

  render() {
    const {
      id,
      webinar_title,
      email,
      user_id,
      booking_experts,
      start_date,
      end_date,
      user_types,
      // sponsor,
      booking_type,
    } = this.props.booking;
    const isSponsor = this.props.isSponsor;
    const ITEM_HEIGHT = 48;
    const is_checked = _.includes(this.props.user_ids, id);
    const { isVisible } = this.state;

    const roleTypes = user_types
      .map((typeIndex) => {
        const foundRole = roles.find((role) => role.value === typeIndex);
        return foundRole ? foundRole.label : "";
      })
      .filter(Boolean)
      .join(", ");

    return isVisible ? (
      <tr>
        <td>
          <p>
            <input
              type="checkbox"
              className="filled-in"
              id="filled-in-box10"
              checked={is_checked}
              key={id}
            />
            <label
              for="filled-in-box10"
              onClick={() => this.props.checkedUserIds(id)}
            ></label>
          </p>
        </td>
        <td>{webinar_title} </td>
        <td>{email}</td>
        <td>{moment(start_date).format("D/M/YYYY h:mm A")}</td>
        <td>{moment(end_date).format("D/M/YYYY h:mm A")}</td>
        <td>{roleTypes}</td>
        <td>
          {booking_experts.map((expert) => (
            <span>{expert.name}</span>
          ))}
        </td>

        {!isSponsor && booking_type === "pending" && (
          <div>
            <div
              className="submit_center col s12"
              onClick={() => this.onBookingApproveHandler()}
            >
              <input className="sign" type="submit" name="" value="Approve" />
            </div>

            <div
              className="submit_center col s12"
              onClick={() => this.onBookingRejectHandler()}
            >
              <input
                className="booking-reject"
                type="submit"
                name=""
                value="Reject"
              />
            </div>
          </div>
        )}
        {!isSponsor ? (
          <div className="submit_center col s12">
            <Link className="edit-button" to={"/calendar/edit_booking/" + id}>
              <i className="material-icons"></i>
              Edit
            </Link>
          </div>
        ) : (
          ""
        )}
      </tr>
    ) : (
      <tr></tr>
    );
  }
}

ApproveBookingItem.defaultProps = {};

ApproveBookingItem.propTypes = {};

export default ApproveBookingItem;



// WEBPACK FOOTER //
// ./src/components/Admin/Calendar/ApproveBooking/ApproveBookingItem.jsx